import { useEffect } from 'react'
import { LOCK_DEAL_MUTATION_STRING } from 'queries/mutations/deal-lock'

interface UseUnlockDealOnUnloadParams {
  dealId: number | null | undefined
  userId: string | null | undefined
  /** Set to false to skip registration (e.g. when action buttons are disabled). Defaults to true. */
  enabled?: boolean
}

/**
 * Registers a beforeunload handler that unlocks the deal via fetch + keepalive
 * when the browser tab is closed or refreshed.
 * fetch is used instead of sendBeacon to support the Authorization header.
 */
export const useUnlockDealOnUnload = ({
  dealId,
  userId,
  enabled = true,
}: UseUnlockDealOnUnloadParams) => {
  useEffect(() => {
    if (!enabled || !dealId || !userId) return

    const token = localStorage.getItem('token')
    const graphqlUri = process.env.REACT_APP_GRAPHQL_URI
    const headerSource = process.env.REACT_APP_GRAPHQL_HEADER_SOURCE

    if (!token || !graphqlUri) return

    const handleBeforeUnload = () => {
      fetch(graphqlUri, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
          source: headerSource ?? '',
        },
        body: JSON.stringify({
          query: LOCK_DEAL_MUTATION_STRING,
          variables: { bdId: dealId, lockFlag: false, userId },
        }),
        keepalive: true,
      })
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [enabled, dealId, userId])
}
